import { render } from "./ActiveCallPage.vue?vue&type=template&id=ef2835aa&scoped=true"
import script from "./ActiveCallPage.vue?vue&type=script&lang=js"
export * from "./ActiveCallPage.vue?vue&type=script&lang=js"

import "./ActiveCallPage.vue?vue&type=style&index=0&id=ef2835aa&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef2835aa"]])

export default __exports__